import CertificationDetails from './CertificationDetails';

export default CertificationDetails;
